import { ProfileDataRow } from "features/PanelManagement/utils/getRowsFromProfileData";
import {
  DEFAULT_INVITE_EMAIL_HTML,
  DEFAULT_INVITE_SUBJECT,
} from "./ViewInvite/defaultInviteEmail";

export const scope = "ParticipantManagement";

export type HydraSelectionMode = "explicit" | "allMatching";

const DEFAULT_GIFT_TYPE = "REGULAR";
const DEFAULT_GIFT_AMOUNT = 5;

export type SetSelectedHydraRowsOptions = {
  mode?: HydraSelectionMode;
};

const CreateParticipantManagementStore = (set, get) => ({
  defaults: {
    email: DEFAULT_INVITE_EMAIL_HTML,
    subject: DEFAULT_INVITE_SUBJECT,
    amount: DEFAULT_GIFT_AMOUNT,
    type: DEFAULT_GIFT_TYPE,
  },
  emailEditor: DEFAULT_INVITE_EMAIL_HTML,
  formInvite: {
    from: "",
    subject: DEFAULT_INVITE_SUBJECT,
    emailContent: "",
  },
  formGift: {
    amount: DEFAULT_GIFT_AMOUNT,
    type: DEFAULT_GIFT_TYPE,
  },
  selectedHydraRows: [] as ProfileDataRow[],
  hydraSelectionMode: "explicit" as HydraSelectionMode,

  useCustomEmail: false,

  setValue: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...get()[scope], [key]: value },
      }),
      false,
      `[${scope}.setValue](${key}, ${JSON.stringify(value)}) `,
    );
  },

  setFormValue: (form: string, key: string, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: {
          ...get()[scope],
          [form]: { ...get()[scope][form], [key]: value },
        },
      }),
      false,
      `${scope} : ${form} : setFormValue`,
    );
  },

  setSelectedHydraRows: (
    next: ProfileDataRow[] | ((prev: ProfileDataRow[]) => ProfileDataRow[]),
    { mode = "explicit" }: SetSelectedHydraRowsOptions = {},
  ) => {
    set(
      (currentState) => {
        const scopeState = get()[scope];
        const selectedHydraRows =
          typeof next === "function"
            ? next(scopeState.selectedHydraRows)
            : next;
        return {
          ...currentState,
          [scope]: {
            ...scopeState,
            selectedHydraRows,
            hydraSelectionMode: mode,
          },
        };
      },
      false,
      `[${scope}.setSelectedHydraRows](mode=${mode}) `,
    );
  },
});

export default CreateParticipantManagementStore;
